<template>
  <div :class="{ 'uk-form-controls': !$attrs.placeholder }">
    <date-picker
      v-bind="$attrs"
      is-expanded
      mode="date"
      v-model="date"
      @input="onDateSelect"
      :value="value"
      :disabled-dates='{ weekdays: [1, 7] }'
      :attributes="datepickerAttr"
      title-position="left" 
      color="gray"
      :model-config="{
        type: 'string',
        mask: 'DD.MM.YYYY'
      }"
    >
    </date-picker>
    <!--<small v-if="error" class="uk-text-danger">{{ error }}</small>-->
  </div>
</template>

<script>
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
export default {
  inject: ['$validator'],

  inheritAttrs: false,
  props: {
    value: {
      required: false,
      Type: String,
      default: ''
    },
    name: {
      required: true,
      Type: String
    },
    error: {
      type: String,
      default: null
    },
    width: {
      required: false,
      type: String,
      default: 'uk-width-1-1'
    }
  },
  components: {
    DatePicker
  },
  data() {
    return {
      date: null,
      datepickerAttr: [
        {
          dot: {
          style: {
              backgroundColor: 'black',
            }
          },
          dates: new Date(),
          highlight: {
            contentStyle: 'black',
          }
        },
      ],
      timeModelConfig: {
        type: 'string',
        mask: 'HH:mm',
      }
    }
  },
  methods: {
    onDateSelect() {
      this.$emit('input', this.date)
    }
  }
}
</script>
